import { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import banner from '../../images/login_bg.jpg';
import logo from '../../images/hitachi_new_png.png';
import apiService from '../../services/api.services';
import { MDBBtn, MDBContainer, MDBCard, MDBCardBody, MDBInput, MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';
import { toast } from 'react-toastify';

export default function Login() {

    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const navigate = useNavigate();
    const [centredModal, setCentredModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);

    const handleFetchData = async () => {
        try {
            await apiService.findUserByEmail(email)
                .then(response => {
                    // console.log('responssseeennnnee',response)

                    if (response.data.message == 'Email is required') {
                        toast.error('Please Enter Email');
                    }

                    if (response.data.message == 'User is blocked'){
                        toast.warn('Access is Blocked, Please Contact Admin');
                    }

                    if (response.data.message == 'User not found'){
                        toast.warn('User not registered, Please Contact Admin');
                    }

                    if (response.data.message == 'OTP sent successfully') {
                        toggleOpen();
                        toast.success('Please check mail for OTP');
                    }
                    
                })
                .catch(err => {
                    toast.error('Blockage in Network, try using different network!')
                    console.log(':::err:::>', err);
                });
        } catch (err) {
            toast.error('An error occurred');
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default behavior (form submit)
            handleFetchData(); // Trigger the login logic
        }
    };

    const handleKeyPressOTP = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent default behavior (form submit)
            verifyOtp(); // Trigger the login logic
        }
    };

    const verifyOtp = async () => {
        try {
            if (otp === '' || /^\d+$/.test(otp)) { setOtp(otp); }
            await apiService.verifyOtp(email, otp)
                .then(response => {
                    if (response) {
                        sessionStorage.setItem('token', response.data.token);
                        sessionStorage.setItem('userId', response.data.userdetail.userId);
                        sessionStorage.setItem('userName', response.data.userdetail.userName);
                        sessionStorage.setItem('emailID', response.data.userdetail.emailId);
                        sessionStorage.setItem('role', response.data.userdetail.role);
                        sessionStorage.setItem('form1', response.data.userdetail.form1);
                        sessionStorage.setItem('form2', response.data.userdetail.form2);
                        sessionStorage.setItem('form3', response.data.userdetail.form3);
                        sessionStorage.setItem('form4', response.data.userdetail.form4);
                        toggleOpen();
                        toast.success(`Welcome to Portal ${response.data.userdetail.userName} San`);
                        navigate('/Home');
                    }
                })
                .catch(err => {
                    toast.error('Wrong OTP');
                    console.log(':::err:::>', err);
                });
        } catch (err) {
            toast.error('An error occurred');
        }

    };

    return (
        <>
            <MDBContainer fluid className='align-items-center vh-100' style={{ backgroundColor: "#E0E0E0", paddingTop: '7%' }}>
                <MDBRow className='g-0 align-items-center'>
                    <MDBCol col='6'>
                        <img src={banner} className="w-100 rounded-4 shadow-4" alt="login_banner_image" fluid='true' />
                    </MDBCol>

                    <MDBCol col='6'>

                        <MDBCard className='my-5 cascading-left' style={{ background: 'hsla(0, 0%, 100%, 0.55)', backdropFilter: 'blur(30px)', borderRadius: '10px' }}>
                            <MDBCardBody className='p-5 shadow-5 text-center'>

                                <div className="text-center">
                                    <img src={logo} style={{ width: '250px' }} alt="logo" />
                                    <h3 className="mb-1 pb-1">Login to DOAlytics Portal</h3>
                                    <h5 className="mt-1 mb-5 pb-1"><i>"Empowering decisions where Authority meets Intelligence"</i></h5>
                                </div>

                                <MDBInput wrapperClass='mb-4' label='Email' id='email' type='text' value={email} onChange={(e) => setEmail(e.target.value)} onKeyDownCapture={handleKeyPress} />

                                <div className="text-center">
                                    <MDBBtn className='w-40 mb-4' size='md' onClick={handleFetchData}>Login</MDBBtn>
                                </div>

                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>

                </MDBRow>

            </MDBContainer>
            <MDBModal tabIndex='-1' open={centredModal} onClose={() => setCentredModal(false)}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Enter OTP</MDBModalTitle>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <MDBInput className='mb-4' label='Enter Otp' id='otp' type='Text' value={otp} onChange={(e) => setOtp(e.target.value)} onKeyDownCapture={handleKeyPressOTP} />
                            <p style={{ fontSize: "10px" }}>Verification OTP sent on your registered email</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn onClick={verifyOtp}>Submit</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

        </>
    );
}

